"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var emotion_1 = require("emotion");

var react_1 = __importDefault(require("react"));

var ThemeContext_1 = require("./theme/ThemeContext");
/**
 * @deprecated Use the `useStyles` hook instead.
 */


function withStyles(WrappedComponent) {
  var Cmp = WrappedComponent;

  var WithStyles =
  /** @class */
  function (_super) {
    __extends(WithStyles, _super);

    function WithStyles() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    WithStyles.prototype.render = function () {
      var _this = this;

      return react_1.default.createElement(ThemeContext_1.ThemeContext.Consumer, null, function (theme) {
        return react_1.default.createElement(Cmp, __assign({}, _this.props, {
          css: emotion_1.css,
          theme: theme
        }));
      });
    };

    WithStyles.displayName = "" + (WrappedComponent.displayName || WrappedComponent.name);
    return WithStyles;
  }(react_1.default.Component);

  return WithStyles;
}

exports.withStyles = withStyles;